// Shared person filter (AMB-387) — ONE component + ONE consistent "Showing tasks for"
// label across My Tasks, Calendar, and the Meeting Digest. Before this, My Tasks read
// "Showing tasks for {…}" while Calendar and Digest read the bare "Person {…}", and each
// screen built its own roster (Calendar even hardcoded a 4-person list). Callers now pass
// the option set: the canonical ROSTER for Tasks/Calendar, the meeting's own attendees for
// the Digest. The label + styling live here so every screen stays in lockstep.

export interface PersonOption {
  id: string;
  name: string;
}

export function PersonFilter({
  value,
  onChange,
  options,
  allLabel = "Everyone",
  className = "",
  label = "Showing tasks for", // AMB-411: callers can change the noun (e.g. "Showing meetings for")
}: {
  value: string;
  onChange: (v: string) => void;
  options: PersonOption[];
  allLabel?: string;
  className?: string;
  label?: string;
}) {
  return (
    <label
      className={`flex items-center gap-1.5 rounded-lg border border-black/[0.06] px-2.5 py-1 text-xs text-gray-600 ${className}`}
    >
      <span className="text-gray-400">{label}</span>
      <select
        value={value}
        onChange={(e) => onChange(e.target.value)}
        aria-label="Filter by person"
        className="cursor-pointer border-0 bg-transparent text-xs font-medium text-gray-700 focus:outline-none focus:ring-0"
      >
        <option value="all">{allLabel}</option>
        {options.map((o) => (
          <option key={o.id} value={o.id}>
            {o.name}
          </option>
        ))}
      </select>
    </label>
  );
}
